export default __webpack_public_path__ + "media/meditationMockup.918a4285.webm";